
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class IssueMaterialDetailsDialog extends _Ext.EditorDialogBase<IssueMaterialDetailsRow> {
        protected getFormKey() { return IssueMaterialDetailsForm.formKey; }
        protected getLocalTextPrefix() { return IssueMaterialDetailsRow.localTextPrefix; }
        protected getNameProperty() { return IssueMaterialDetailsRow.nameProperty; }
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }
        public OrderItem: any;
        public form = new IssueMaterialDetailsForm(this.idPrefix);
        constructor() {
            super();


            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 250;
            q.SetCategoryFullWidth(this.form.ItemDetails);
            q.initDetailEditor(this, this.form.ItemDetails, Config);
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.RequiredPieces);
            q.setTextRightAlign(this.form.RequiredWeight);
            q.HideCategoryLable(this.element);
            this.form.DepartmentId.changeSelect2(e => {
                //this.form.BagNo.cascadeField = "DepartmentId";
                //this.form.BagNo.cascadeValue = this.form.DepartmentId.value.toString();
                this.form.ItemDetails.DeptId = parseInt(this.form.DepartmentId.value);
            });
            this.form.BagNo.changeSelect2(e => {
                this.form.ItemDetails.BagNo = this.form.BagNo.value;
                let oldworkorderdetails: WIPMovementRow;
                WIPMovementSelectService.List({ BagNo: this.form.BagNo.value, DepartmentId: parseInt(this.form.DepartmentId.value) }, response => oldworkorderdetails = response.Entities[0], { async: false });


                this.form.Line_No.value = oldworkorderdetails.Line_No.toString();
                this.form.SubBagNo.value = oldworkorderdetails.SubBagNo;
                this.form.ProductId.value = oldworkorderdetails.ProductId.toString();
                this.form.AttributeId.value = oldworkorderdetails.AttributeId.toString();
                this.form.Attribute.value = oldworkorderdetails.Attribute;
                this.form.ItemDetails.Line_No = parseInt(this.form.Line_No.value);
                this.form.Pieces.value = oldworkorderdetails.Pieces;
                this.form.ProductCode.value = oldworkorderdetails.ProductCode;

                var productImage = oldworkorderdetails.ImageName;
                var image: Serenity.UploadedFile = {
                    Filename: productImage,
                    OriginalName: ""
                }
                if (oldworkorderdetails.OrderTypeId == 16) {
                    let salesdetails: SalesOrder.SalesOrderRow;
                    SalesOrder.SalesOrderService.GetCustomerandProductDetails({ EntityId: oldworkorderdetails.OrderId }, response => salesdetails = response.Entity, { async: false });

                    var pcs = 0, wt = 0;
                    var orderitems = salesdetails.ItemDetails.filter(x => x.ProductId == parseInt(this.form.ProductId.value) && x.AttributeId == parseInt(this.form.AttributeId.value));
                    for (var i = 0; i < orderitems.length; i++) {
                        pcs += orderitems[i].Pieces;
                        wt += orderitems[i].Weight;
                    }
                    this.form.RequiredPieces.value = pcs;
                    this.form.RequiredWeight.value = wt;

                } else if (oldworkorderdetails.OrderTypeId == 47) {

                    let posdetails: Retail.POSOrderRow;
                    Retail.POSOrderService.GetCustomerandProductDetails({ EntityId: oldworkorderdetails.OrderId }, response => posdetails = response.Entity, { async: false });

                    var pcs = 0, wt = 0;
                    var posorderitems = posdetails.ItemDetails.filter(x => x.ProductId == parseInt(this.form.ProductId.value) && x.AttributeId == parseInt(this.form.AttributeId.value));
                    for (var i = 0; i < posorderitems.length; i++) {
                        pcs += posorderitems[i].Pieces;
                        wt += posorderitems[i].Weight;
                    }
                    this.form.RequiredPieces.value = pcs;
                    this.form.RequiredWeight.value = wt;
                }


            });


            (this.form.ItemDetails.view as any).onRowCountChanged.subscribe(() => {
                this.CalculateTotals();
            });

            var fieldEditor: JQuery = this.form.BagNo.element.closest(".editor");
            fieldEditor.addClass("has-inplace-button");
            $(' <button type="button">...</button>')
                .addClass('inplace-button')
                .addClass('inplace-search edit')
                .attr('title', 'Search')
                .insertAfter(fieldEditor)
                .click((e) => { this.inplaceSearchClick(e) }
                );


        }
        public CalculateTotals() {
            var Wt = 0, diapcs = 0, clrpcs = 0, cts = 0, gms = 0, rate = 0;
            for (var k of this.form.ItemDetails.getItems()) {

                if (k.ItemTypeId == 104) {
                    Wt += k.Weight;
                }
                if (k.ItemTypeId == 105 && k.CalcOnId == 5) {
                    cts += k.Weight;
                    diapcs += k.Pieces
                }
                if (k.ItemTypeId == 105 && k.CalcOnId == 4) {
                    gms += k.Weight;
                    clrpcs += k.Pieces;
                }


                if (cts > 0)
                    this.form.Weight.value = Wt + gms + (cts / 5);
                else
                    this.form.Weight.value = Wt + gms;

                this.form.Pieces.value = clrpcs + diapcs;
                //rate += k.BomAmount;

                if (this.form.ItemDetails.getItems().length > 0) {
                    q.showAndDisableField(this.form.BagNo);
                    q.showAndDisableField(this.form.DepartmentId);
                }

            }
        }

        protected inplaceSearchClick(e: any): void {
            if (!this.isViewMode()) {
                if (this.form.ItemDetails.getItems().length == 0) {
                    var grid = WIPMovementSelectGrid;
                    var filters: _Ext.SelectGridFilters = {
                        PartyId: 0,
                        DepartmentId: Q.parseInteger(this.form.DepartmentId.value)


                    }

                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: false, title: "Select Work Order", height: 500, Width: 750, GridFilters: filters
                    });

                    pickerDialog.onSuccess = (selectedItems: WIPMovementRow[]) => {

                        if (selectedItems.length > 0) {
                            this.form.BagNo.value = selectedItems[0].BagNo;
                            this.form.ItemDetails.BagNo = selectedItems[0].BagNo;
                            this.form.SubBagNo.value = selectedItems[0].SubBagNo;

                            this.form.Line_No.value = selectedItems[0].Line_No.toString();
                            this.form.ProductId.value = selectedItems[0].ProductId.toString();
                            this.form.AttributeId.value = selectedItems[0].AttributeId.toString();
                            // this.form.Attribute.value = selectedItems[0].Attribute;
                            this.form.ItemDetails.Line_No = parseInt(this.form.Line_No.value);
                            this.form.Pieces.value = selectedItems[0].Pieces;
                            this.form.ProductCode.value = selectedItems[0].ProductCode;

                            if (selectedItems[0].OrderTypeId == 16) {
                                let salesdetails: SalesOrder.SalesOrderRow;
                                SalesOrder.SalesOrderService.GetCustomerandProductDetails({ EntityId: selectedItems[0].OrderId },
                                    response => {
                                        salesdetails = response.Entity;
                                        var item = salesdetails.ItemDetails.filter(x => x.ProductId.toString() == this.form.ProductId.value && x.AttributeId.toString() == this.form.AttributeId.value
                                            && x.Line_No.toString() == this.form.Line_No.value)[0];
                                        this.OrderItem = item;
                                    }, { async: false });

                                var pcs = 0, wt = 0;
                                var orderitems = salesdetails.ItemDetails.filter(x => x.ProductId == parseInt(this.form.ProductId.value) && x.AttributeId == parseInt(this.form.AttributeId.value));
                                for (var i = 0; i < orderitems.length; i++) {
                                    pcs += orderitems[i].Pieces;
                                    wt += orderitems[i].Weight;
                                }
                                this.form.RequiredPieces.value = pcs;
                                this.form.RequiredWeight.value = wt;

                            } else if (selectedItems[0].OrderTypeId == 47) {

                                let posdetails: Retail.POSOrderRow;
                                Retail.POSOrderService.GetCustomerandProductDetails(
                                    { EntityId: selectedItems[0].OrderId }, response => {
                                        posdetails = response.Entity;
                                        var item = posdetails.ItemDetails.filter(x => x.ProductId.toString() == this.form.ProductId.value && x.AttributeId.toString() == this.form.AttributeId.value
                                            && x.Line_No.toString() == this.form.Line_No.value)[0];
                                        this.OrderItem = item;
                                    }, { async: false });

                                var pcs = 0, wt = 0;
                                var posorderitems = posdetails.ItemDetails.filter(x => x.ProductId == parseInt(this.form.ProductId.value) && x.AttributeId == parseInt(this.form.AttributeId.value));
                                for (var i = 0; i < posorderitems.length; i++) {
                                    pcs += posorderitems[i].Pieces;
                                    wt += posorderitems[i].Weight;
                                }
                                this.form.RequiredPieces.value = pcs;
                                this.form.RequiredWeight.value = wt;
                            } else if (selectedItems[0].OrderTypeId == 0) {
                                let productdetails: OMS.ProductMasterRow;
                                OMS.ProductMasterService.Retrieve({
                                    EntityId: selectedItems[0].ProductId
                                }, response => {
                                    if (response.Entity != null) {
                                        this.OrderItem = response.Entity;
                                        this.form.RequiredPieces.value = response.Entity.Pieces;
                                        this.form.RequiredWeight.value = response.Entity.Weight;
                                    }
                                }, { async: false })
                            }

                            //this.CalculateTotals();
                        }
                    }
                    pickerDialog.dialogOpen();
                }
            }
            else
                q.Alert("View Mode", "Can not make changes in view mode", 2000, false);
        }


    }
}